import GavelIcon from '@material-ui/icons/Gavel';
import StatSection from './StatSection';
import BarList from './BarList';
import { ACCEPTED_COLOR, REJECTED_COLOR, CE_COLOR } from './palette';
// the streaming slideshow writes verdicts out the same way, so the names live
// beside the other formatting helpers
import verdictLabel from '../../../utils/verdictLabels';

// Every verdict the judge has ever recorded, so a verdict this contestant never
// got is still listed - at zero
function VerdictCard(props) {
    const verdicts = props.verdicts ?? [];
    const total = props.submissions ?? 0;
    return (
        <StatSection
            icon={<GavelIcon />}
            title='Submission Verdicts'
        >
            <BarList
                emptyMessage='No submission has been judged yet'
                items={verdicts.map(verdict => ({
                    key: verdict.verdict,
                    label: verdictLabel(verdict.verdict),
                    value: verdict.count,
                    valueLabel: `${verdict.count} · ${verdict.percentage.toFixed(1)}%`,
                    color: verdict.verdict === 'OK' ? ACCEPTED_COLOR : (verdict.verdict === "COMPILATION_ERROR" ? CE_COLOR : REJECTED_COLOR),
                    tooltip: `${verdict.verdict}: ${verdict.count} of ${total} submissions`
                }))}
            />
        </StatSection>
    );
}

export default VerdictCard;
